import { toastr } from "react-redux-toastr";
import { client_v2, stringifyQuery } from "utils/api";

export const toggleFilters = () => (dispatch) =>
  dispatch({ type: "STATIONS_TOGGLE_FILTERS" });

export const resetFilters = () => (dispatch) =>
  dispatch({ type: "STATIONS_RESET_FILTERS" });

export const filterStations = (query) => async (dispatch) =>
  dispatch({ type: "STATIONS_SET_FILTERS_QUERY", query });

export const getStations = ({
  page = 1,
  per_page = 50,
  ...rest
}) => async (dispatch, getState) => {
  try {
    const {
      status,
      filters: { query },
    } = getState().stations;

    dispatch({
      type:
        status === "invalid"
          ? "STATIONS_LOADING"
          : "STATIONS_SEARCHING",
    });

    const { data, meta } = await client_v2.get(
      `/packing_stations?${stringifyQuery({
        ...rest,
        page,
        per_page,
        ...query,
      })}`
    );

    dispatch({
      type: "STATIONS_SUCCESS",
      data,
      meta,
    });
  } catch (error) {
    dispatch({ type: "STATIONS_FAILURE" });
    toastr.error(
      "Błąd",
      "Wystąpił błąd podczas pobierania"
    );
  }
};
